import { useState, type ReactNode } from 'react';
import { useHomeLayout } from '../../lib/home-store.js';
import { EditModeProvider } from '../home/edit-context.js';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';
import { useAuth } from '../../lib/auth.js';
import { useSidebarCollapsed } from '../../lib/sidebar-state.js';
import { useFavicon } from '../../lib/use-favicon.js';
import { useApplyTheme } from '../../lib/theme.js';
import { MfaEnroll } from '../security/MfaEnroll.js';

export function Layout({ children }: { children: ReactNode }) {
  const { layout } = useHomeLayout();
  const { role, mfaEnrolled, user } = useAuth();
  const [collapsed, setCollapsed] = useSidebarCollapsed();
  const [enrollDismissed, setEnrollDismissed] = useState(false);
  useFavicon(layout.brand.logoUrl, layout.brand.name);
  useApplyTheme();

  // First-time enrollment gate. Google-signed-in users who go straight from
  // popup → app have no MFA yet; require them to enroll before reaching the
  // home base. The user can fully complete this from inside the modal.
  const showEnroll = !!user && !mfaEnrolled && !enrollDismissed;

  return (
    <EditModeProvider>
      <div className="flex h-screen overflow-hidden bg-[color:var(--sfp-canvas)] text-stone-800">
        <Sidebar
          layout={layout}
          role={role}
          collapsed={collapsed}
          onToggleCollapse={() => setCollapsed(!collapsed)}
        />
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar layout={layout} onMenuClick={() => setCollapsed(!collapsed)} />
          <main className="flex-1 overflow-y-auto">{children}</main>
        </div>
        {showEnroll && <MfaEnroll mode="modal" onDone={() => setEnrollDismissed(true)} />}
      </div>
    </EditModeProvider>
  );
}
